import React from 'react';
import { useTranslation } from 'react-i18next';
import './StockIndicator.scss';

interface StockIndicatorProps {
  stockQuantity: number;
  maxStock: number;
  minStockThreshold: number;
  isAvailable: boolean;
  showDetails?: boolean;
}

const StockIndicator: React.FC<StockIndicatorProps> = ({
  stockQuantity,
  maxStock,
  minStockThreshold,
  isAvailable,
  showDetails = false
}) => {
  const { t } = useTranslation();

  const getStockStatus = () => {
    if (!isAvailable) {
      return {
        status: 'out-of-stock',
        label: t('stock.outOfStock'),
        color: 'red'
      };
    }

    if (stockQuantity <= 0) {
      return {
        status: 'out-of-stock',
        label: t('stock.outOfStock'),
        color: 'red'
      };
    }

    if (stockQuantity <= minStockThreshold) {
      return {
        status: 'low-stock',
        label: t('stock.lowStock'),
        color: 'orange'
      };
    }

    return {
      status: 'in-stock',
      label: t('stock.inStock'),
      color: 'green'
    };
  };

  const stockStatus = getStockStatus();
  const showStockLabel = stockStatus.status !== 'in-stock';
  const stockPercentage = maxStock > 0 ? (stockQuantity / maxStock) * 100 : 0;

  return (
    <div className="stock-indicator">
      {showStockLabel && (
      <div className={`stock-indicator__status stock-indicator__status--${stockStatus.status}`}>  
        <span className="stock-indicator__label">{stockStatus.label}</span>
      </div>
      )}
      {showDetails && (
        <div className="stock-indicator__details">
          <div className="stock-indicator__quantity">
            {t('stock.quantity')}: {stockQuantity}
          </div>
          <div className="stock-indicator__bar">
            <div 
              className="stock-indicator__bar-fill"
              style={{ width: `${Math.min(stockPercentage, 100)}%` }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StockIndicator; 